import { useLazyQuery } from "@apollo/client/react";
import { useEffect, useState } from "react";
import { GET_MONTOS_LIQUIDACIONES_ANTERIORES } from "../../../data/graphQL/queries/PreLiquidacion/getMontosLiquidaciones";

const initialMontos = {
    totalMesAnterior: 0,
    totalMesAnteAnterior: 0
};

export const useGetMontosLiquidacion = () => {
    const [montos, setMontos] = useState(initialMontos);

    const [getMontos, { data, loading }] = useLazyQuery(GET_MONTOS_LIQUIDACIONES_ANTERIORES, {
        fetchPolicy: 'no-cache'
    });

    const fetchMontos = (filters) => {
        getMontos({
            variables: {
                input: {
                    mes: filters.mes,
                    anio: filters.anio,
                    idTipoProfesional: filters.idTipoProfesional,
                    idDelegacion: filters.idDelegacion
                }
            }
        });
    };

    useEffect(() => {
        const valor = data?.montosLiquidacionesAnteriores?.valorEsperado;
        setMontos(valor ?? initialMontos);
    }, [data]);

    return {
        montos,
        fetchMontos,
        loading
    };
};